import { render } from "./company-certification.vue?vue&type=template&id=63a2ab5f&scoped=true"
import script from "./company-certification.vue?vue&type=script&lang=js"
export * from "./company-certification.vue?vue&type=script&lang=js"

import "./company-certification.vue?vue&type=style&index=0&id=63a2ab5f&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a2ab5f"]])

export default __exports__